import React, { useState, useEffect } from 'react';
import { connect } from "trim-redux";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../../config/design/styles';
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import AddressHolder from "../../../../components/address/map/AddressHolder";
import {useSnackbar} from "notistack";


const CourierAddress = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    let { id } = useParams();
    if(!id && !props.create){
        if(!!props.user.shop){
            id = props.user.shop.id;
        }else{
            navigation('/')
        }
    }

    const [loading, setLoading] = useState(false);
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    /*const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/users/get/${id}`,config)
            .then(response => {
                setShopData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }*/
    useEffect(() => {
        //loadData();
    }, []);

    const handleAddressDone = () => {
        enqueueSnackbar(t('detailsSet'), { variant: 'success' });
    }

    if (loading) {
        return <AppCardLoaderFields />;
    }
    return (
        <Grid container spacing={2} justify="center" alignItems="center">
            <Grid item size={{xs:12}}>
                <AddressHolder
                    vendor
                    courier_id={id}
                    handleAddressDone={() => handleAddressDone()}
                    radius={props.setting.courier_radius}
                />
            </Grid>
        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    setting: state.setting
});

export default withStyles(Styles)(connect(mstp)(CourierAddress));
